import { ReducerBuilder } from './reducerBuilder';
import { GetPastModificationsRequest } from 'acscp/api/requests';
import { BookingModificationRequestsState } from 'acscp/store';
import { ModificationRequestsList } from 'acscp/api/models/bookingModificationRequestsList';

export const bookingModificationRequestsReducer =
    new ReducerBuilder<BookingModificationRequestsState>({})
        .successfulRequestCase(GetPastModificationsRequest, (state, response: ModificationRequestsList) => ({
            ...state,
            [response.bookingId]: response.modificationRequests
        }))
        .build();
